import React from "react";
import { FormGroup, FormLabel, FormSelect, FormControl, InputGroup } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getError } from "../../shared/utils";

const Select = ({
    label,
    name,
    rules,
    options = [],
    placeholder = "PLEASE_SELECT",
    leftElement,
    rightElement,
    containerProps,
    selectProps
}) => {
    const { t } = useTranslation();
    const {
        register,
        formState: { errors },
    } = useFormContext();

    const error = getError(errors, name);

    return (
        <FormGroup className="mb-3" {...containerProps}>
            {label && <FormLabel htmlFor={name}>{label}{rules?.required && <span className="text-danger ms-1">*</span>}</FormLabel>}
            <InputGroup hasValidation>
                {leftElement && <InputGroup.Text>{leftElement}</InputGroup.Text>}
                <FormSelect
                    id={name}
                    {...register(name, rules)}
                    isInvalid={!!error}
                    {...selectProps}
                >
                    <option value="" disabled hidden>{t(placeholder)}</option>
                    {options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </FormSelect>
                {rightElement && <InputGroup.Text>{rightElement}</InputGroup.Text>}
                <FormControl.Feedback type="invalid">
                    {error?.message}
                </FormControl.Feedback>
            </InputGroup>
        </FormGroup>
    );
};

export default Select;
